import type { PointLabelObject, Series } from 'highcharts/highcharts';

/** Get the color for point or series for display in a tooltip */
export function getChartSeriesColor(
  data:
    | { point?: { color?: PointLabelObject['color'] | undefined }; series?: { color?: Series['color'] | undefined } }
    | undefined
) {
  if (!data) {
    return undefined;
  }
  return typeof data.point?.color === 'string'
    ? data.point.color
    : typeof data.series?.color === 'string'
      ? data.series.color
      : undefined;
}
